// extracted by mini-css-extract-plugin
export default {"gifts":"gifts__gifts__2o9mW","gifts__table":"gifts__gifts__table__1JHKP","block":"gifts__block__2TEiA"};